import { rankingData } from '@/mocks/chiguaHomeData';

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            吃瓜热度榜
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
            实时追踪最火爆的今日吃瓜话题，热度排名每小时更新
          </p>
        </div>

        <div className="max-w-3xl mx-auto">
          {rankingData.map((item, i) => (
            <a
              key={i}
              href="#cards"
              onClick={(e) => {
                e.preventDefault();
                document.querySelector('#cards')?.scrollIntoView({ behavior: 'smooth' });
              }}
              className="flex items-center gap-4 p-4 rounded-lg hover:bg-background-100 transition-colors cursor-pointer group border-b border-background-200/60 last:border-b-0"
            >
              <div className={`w-8 h-8 flex items-center justify-center rounded-lg font-heading font-bold text-sm shrink-0 ${
                i < 3 ? 'bg-primary-500 text-background-50' : 'bg-background-200 text-foreground-500'
              }`}>
                {item.rank}
              </div>

              <div className="flex-1 min-w-0">
                <h3 className="text-sm md:text-base text-foreground-900 font-medium group-hover:text-primary-500 transition-colors truncate">
                  {item.title}
                </h3>
              </div>

              <span className={`shrink-0 px-2 py-0.5 rounded text-[11px] font-medium whitespace-nowrap ${
                item.tag === '爆' ? 'bg-primary-100 text-primary-700' :
                item.tag === '热' ? 'bg-accent-100 text-accent-700' :
                'bg-secondary-100 text-secondary-700'
              }`}>
                {item.tag}
              </span>

              <div className="flex items-center gap-1 text-xs text-foreground-500 shrink-0 w-20 justify-end">
                <i className={`text-[10px] ${item.trend === 'up' ? 'ri-arrow-up-line text-primary-500' : 'ri-arrow-down-line text-foreground-400'}`}></i>
                <span>{item.heat}</span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}